import { Injectable } from '@angular/core';
import { BackendService } from 'core-lib';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserAccountService {

  constructor(private backendSvc: BackendService) { }

  public getList(filter: any, permitNo: String): Observable<AdminListModel> {

    let queryString = '';
    if (filter) {
      queryString = queryString + '?searchText=' + (!filter.search ? '' : filter.search);
      queryString = queryString + '&orderBy=' + (!filter.orderBy ? '' : filter.orderBy);
      queryString = queryString + '&isDesc=' + (!filter.isDesc ? 'false' : filter.isDesc ? 'true' : 'false');
      queryString = queryString + '&skip=' + (!filter.skip ? '0' : filter.skip);
      queryString = queryString + '&take=' + (!filter.take ? '0' : filter.take);
      queryString = queryString + '&permitNo=' + permitNo;
    }

    let url = `${environment.apiURL}client/permit/users` + queryString;

    return this.backendSvc.get(url)
      .pipe(map((n: AdminListResponse) => {
        return n.data;
      })
      );
  }

  public getDetails(permitNo: string, id: number): Observable<AdminDetailsModel> {

    let url = `${environment.apiURL}client/permit/${permitNo}/users/${id}`

    return this.backendSvc.get(url)
      .pipe(map((n: AdminDetailsResponse) => {
        return n.data;
      })
      );
  }

  public createAdmin(data: AdminDetails): Observable<AdminDetailsModel> {

    return this.backendSvc.post(`${environment.apiURL}client/permit/users`, data).pipe(map((n: AdminDetailsResponse) => {
      return n.data;
    }));

  }

  public updateAdmin(data: AdminDetails): Observable<AdminDetailsModel> {

    return this.backendSvc.put(`${environment.apiURL}client/permit/users/` + data.userId, data).pipe(map((n: AdminDetailsResponse) => {
      return n.data;
    }));
  }

  public deleteAdmin(userId: number): Observable<boolean> {
    let url = `${environment.apiURL}client/permit/users/` + userId;
    return this.backendSvc.delete(url).pipe(map((n: AdminDeleteResponse) => {
      return true;
    }));
  }

  public sendInstallation(permitNo: string, id: string): Observable<boolean> {
    return this.backendSvc.post(`${environment.apiURL}client/permit/users/msg`, { permitId: permitNo, userId: id }).pipe(map((n: AdminDetailsResponse) => {
      return true;
    }));
  }

}

export class AdminDeleteResponse {
  public code: number;
  public message: string;
}

export class AdminListResponse {
  public code: number;
  public message: string;
  public data: AdminListModel;
}

export class AdminListModel {
  public items: AdminListItemModel[];
  public totalCount: number;
}

export class AdminListItemModel {

  public userId: number;
  public userName: string;
  public fullName: string;
  public email: string;
  public status: string;

}

export class AdminDetailsResponse {
  public code: number;
  public message: string;
  public data: AdminDetailsModel;
}

export class AdminDetailsModel {
  public adminDetails: AdminDetails;
}

export class AdminDetails {
  public userId: number;
  public userName: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public isActive: boolean;
  public password: string;
  public permitId: string;
}
